<div class="gb-dialog-header">
  <h1>{{ 'PRESENTER.RAFFLE_ITEM_DIALOG.TITLE' | translate }}</h1>

  <button mat-icon-button mat-dialog-close>
    <gb-icon icon="close"></gb-icon>
  </button>
</div>

@if (raffleItemsLoaded$ | async) {
  <div class="gb-dialog-content">
    @if ((raffleItems$ | async)?.length) {
      <p>{{ 'PRESENTER.RAFFLE_ITEM_DIALOG.DESCRIPTION' | translate }}</p>
      <mat-form-field class="raffle-item-form-field">
        <mat-label>{{ 'PRESENTER.RAFFLE_ITEM_DIALOG.SELECT_LABEL' | translate }}</mat-label>
        <mat-select [formControl]="raffleItemControl">
          @for (item of raffleItems$ | async; track item.uuid) {
            <mat-option [value]="item.raffle_item?.uuid">{{ item.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else {
      <div class="callout-warning">
        <gb-icon icon="warning"></gb-icon>
        <span>{{ 'PRESENTER.RAFFLE_ITEM_DIALOG.EMPTY_STATE_MESSAGE' | translate }}</span>
      </div>
    }
  </div>

  <div class="gb-flex-button-container gb-dialog-actions-container">
    <button mat-stroked-button type="button" (click)="continueWithoutRaffleItem()">
      {{ 'PRESENTER.RAFFLE_ITEM_DIALOG.CONTINUE_WITHOUT' | translate }}
    </button>

    @if ((raffleItems$ | async)?.length) {
      <button mat-flat-button type="button" [disabled]="raffleItemControl.invalid" (click)="confirmSelection()">
        {{ 'PRESENTER.RAFFLE_ITEM_DIALOG.CONFIRM' | translate }}
      </button>
    } @else {
      <button mat-flat-button type="button" (click)="goToItemsList()">
        {{ 'PRESENTER.RAFFLE_ITEM_DIALOG.GO_TO_ITEMS_LIST' | translate }}
      </button>
    }
  </div>
} @else {
  <div class="raffle-item-spinner-container">
    <mat-spinner [diameter]="24"></mat-spinner>
  </div>
}
